
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audyt-kodu-i-modernizacja-legacy",
      function () {
        return require("private-next-pages/audyt-kodu-i-modernizacja-legacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audyt-kodu-i-modernizacja-legacy"])
      });
    }
  